import React, { useState, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import OnboardingSection from "./sections/OnboardingSection";
import ClanManagementSection from "./sections/ClanManagementSection";
import ProfileSection from "./sections/ProfileSection";
import MyGamesDashboardSection from "./sections/MyGamesDashboardSection";
import SpectateSection from "./sections/SpectateSection";
import "./PlatformWalkthrough.css";

const PlatformWalkthrough = () => {
  const [activePhase, setActivePhase] = useState("onboarding");
  const scrollRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 150;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setShowLeft(scrollLeft > 10);
      setShowRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  return (
    <div className="walkthrough-page">
      <header className="walkthrough-header">
        <h1>Platform Walkthrough</h1>

        <div className="nav-wrapper">
          <button
            className={`nav-arrow left ${showLeft ? "visible" : ""}`}
            onClick={() => scroll("left")}
          >
            <ChevronLeft size={16} />
          </button>

          <nav className="guide-nav" ref={scrollRef} onScroll={handleScroll}>
            <button
              className={activePhase === "onboarding" ? "active" : ""}
              onClick={() => setActivePhase("onboarding")}
            >
              Onboarding
            </button>
            <button
              className={activePhase === "profile" ? "active" : ""}
              onClick={() => setActivePhase("profile")}
            >
              Profile & IGN
            </button>
            <button
              className={activePhase === "management" ? "active" : ""}
              onClick={() => setActivePhase("management")}
            >
              Clan Management
            </button>
            <button
              className={activePhase === "myGames" ? "active" : ""}
              onClick={() => setActivePhase("myGames")}
            >
              My Games
            </button>
            <button
              className={activePhase === "spectate" ? "active" : ""}
              onClick={() => setActivePhase("spectate")}
            >
              Spectate
            </button>
          </nav>

          <button
            className={`nav-arrow right ${showRight ? "visible" : ""}`}
            onClick={() => scroll("right")}
          >
            <ChevronRight size={16} />
          </button>
        </div>
      </header>

      <main className="walkthrough-content">
        {activePhase === "onboarding" && <OnboardingSection />}
        {activePhase === "profile" && <ProfileSection />}
        {activePhase === "management" && <ClanManagementSection />}
        {activePhase === "myGames" && <MyGamesDashboardSection />}
        {activePhase === "spectate" && <SpectateSection />}
      </main>
    </div>
  );
};

export default PlatformWalkthrough;
